import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { selectors as userSelectors } from '@saucelabs/sl-module-user';

import * as globalConstants from '../../constants';
import { selectors as testConfigurationSelectors } from '../testConfiguration';
import types from './types';
import api from './api';
import selectors from './selectors';

type UpdateTestDetailsArgument = {
  name: string;
  passed?: boolean;
};

const updateTestDetails = createAsyncThunk(
  types.UPDATE_TEST_DETAILS,
  async (newTestDetails: UpdateTestDetailsArgument, { getState, rejectWithValue }) => {
    try {
      // need "any" for userSelectors
      const state = getState() as any; // eslint-disable-line @typescript-eslint/no-explicit-any
      const currentUserID = userSelectors.getCurrentUserID(state);
      const deviceType = testConfigurationSelectors.deviceTypeSelector(state);
      const testId = selectors.testIdSelector(state);
      const isRealDevice = deviceType === globalConstants.CONFIGURATION_DEVICE_TYPES.REAL_DEVICE;

      const testDetails = {
        id: testId,
        name: newTestDetails.name,
        passed: newTestDetails.passed,
      };

      if (isRealDevice) {
        const realDeviceTestDetailsResponse = await api.updateRealDeviceJob(testDetails);
        return realDeviceTestDetailsResponse.data;
      }

      const virtualTestDetailsResponse = await api.updateVirtualJob(currentUserID, testDetails);
      return virtualTestDetailsResponse.data;
    } catch (error: any) { // eslint-disable-line @typescript-eslint/no-explicit-any
      if (axios.isAxiosError(error)) {
        return rejectWithValue({
          code: error.response?.status,
          detail: error.response?.data,
          title: error.response?.statusText,
        });
      }

      return rejectWithValue({
        code: 500,
        detail: (error as Error).message,
        title: (error as Error).name,
      });
    }
  },
);

export default {
  updateTestDetails,
};
